






























































import DeletedDocumentService from '@/services/deletedDocument/DeletedDocumentService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    SnackbarMessageHandler,
  },

  data: () => ({
    term: '' as string,
    deletedDocuments: [] as any[],
    errorMessage: '' as string,
    nextPointer: undefined as string | undefined,
    totalCount: 0 as number,
    deletedDocumentService: new DeletedDocumentService(),
  }),

  computed: {
    hasNext(): boolean {
      return typeof this.nextPointer === 'string';
    },
  },

  mounted() {
    this.fetchDeletedDocuments();
  },

  watch: {
    $route() {
      this.fetchDeletedDocuments();
    },
  },

  methods: {
    search() {
      this.deletedDocuments = [];
      this.nextPointer = undefined;
      this.fetchDeletedDocuments();
    },

    fetchDeletedDocuments() {
      this.deletedDocumentService.getDeletedDocuments({
        term: this.term || undefined,
        next: this.nextPointer,
      }).then((response) => {
        this.deletedDocuments = this.deletedDocuments.concat(response.data);
        this.nextPointer = undefined;

        if (response.headers.total_count) {
          this.totalCount = response.headers.total_count;
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        }

        if (this.deletedDocuments.length === 0) {
          this.errorMessage = 'No deleted documents found.';
        }
      }).catch(() => {
        this.errorMessage = 'Failed to load deleted documents.';
      });
    },

    requestNextPage() {
      this.fetchDeletedDocuments();
    },
  },
});
